import jsPDF from 'jspdf';
import moment from 'moment';
import { drawCabeceraFiscalEmpresa } from './empresa_pdf';
import helpers from './helpers';

/* Agregar imagen: addImage ( source, tipo, posicionX, posicionY, ancho, alto) */
/* addImage ( 'img.png', 'PNG', 100, 100, 50, 50) */
/* Agregar texto: text(texto, posicionX, posicionY) (se puede usar setFont, setFontSize, setTextColor, setFontType) */
/* pdf.setFontSize(20); pdf.setFont("times"); pdf.setFontType("bold"); pdf.setTextColor(255, 0, 0); */
/* A4: 210mm x 297 mm */


export default {
  methods: {
    exportFacturaPDF (venta, renglones, empresa) {
      let pdfName = 'factura_'; 
      pdfName = pdfName.concat(venta.numero.toString().trim()); 
      /* Parametros: portrait, milimetros, A4 */
      var doc = new jsPDF('p', 'mm', 'a4');

      doc.setProperties({
        title: 'Factura',
        subject: 'Factura',		
        author: 'Cervertti - Marketing & Eventos',
        creator: 'Cervetti'
      });

      // let fontName = 'CenturyGothic';
      // let fontBoldName = 'CenturyGothicBold';
      // let fontItalicName = 'CenturyGothicItalic';
      // let fontBoldItalicName = 'CenturyGothicBoldItalic';

      let fontName = 'Montserrat-Regular';
      let fontBoldName = 'Montserrat-Bold';
      let fontItalicName = 'Montserrat-Italic';
      let fontBoldItalicName = 'Montserrat-BoldItalic';

      // venta.cuit = this.$options.filters.cuit(venta.cuit);
      venta.documentoNumero = this.$options.filters.cuit(venta.documentoNumero);

      /* Limite para el salto de página */
      let positionMaxY = 220;
      /* Limite para incluir totales y datos de facturacion */
      let positionTotalesY = 228;

      /* Interlineado */
      let interlineadoRenglones = 5;
      let interlineadoTotales = 5;

      /* Formato para alinear numeros a la derecha */
      let alignRight = {
        'align': 'right'
      }

      let positionY = drawCabecera(doc, empresa, venta, 
        fontName, fontBoldName, fontItalicName, fontBoldItalicName);
      positionY += 5;

      if (renglones) {
        /* Titulo de los renglones */
        doc.setTextColor(60, 60, 60);
        doc.setFont(fontBoldName, 'bold');
        // doc.setFontType('normal');

        doc.text('Servicio', 10, positionY);
        doc.text('Importe', 200, positionY, alignRight);

        for(let key in renglones) {
          const renglon = renglones[key];

          /* Verificamos si necesitamos agregar una nueva pagina */
          if (positionY + interlineadoRenglones > positionMaxY) {
            /* Agregamos una nueva pagina */
            doc.addPage();
            positionY = drawCabecera(doc, empresa, venta, 
              fontName, fontBoldName, fontItalicName, fontBoldItalicName);
          }

          positionY += interlineadoRenglones;

          doc.setFontSize(7);
          doc.setFont(fontName, 'normal');
          // doc.setFontType('normal');

          doc.text(renglon.descripcion, 10, positionY);

          if (renglon.importe != 0) {
            let importeRenglon = renglon.importe;
            if (venta.formulario == 'B') {
              let pjeIva = helpers.methods.roundToTwo(1 + venta.pjeAlicuotaIva / 100);
              
              importeRenglon = helpers.methods.roundToTwo(importeRenglon * pjeIva);
            }
            doc.text(this.$options.filters.numero(importeRenglon, 2), 200, positionY, alignRight);
          }
        }
      }

      /* Leyenda FCE */
      if (parseInt(venta.afipComprobante) > 200) {
        doc.setFont(fontName, 'normal');
        doc.setFontSize(6);
        // doc.setFontType('normal');
        doc.setTextColor(151, 148, 149);
        positionY = positionTotalesY;
        let cadena = 'Este comprobante se considerará aceptado si, al vencimiento del plazo de quince (15) días corridos desde su recepción en el domicilio fiscal electrónico del comprador o locatario,';
        doc.text(cadena, 10, positionY);
        positionY = positionY + 3;
        cadena = 'no se hubiera registrado su rechazo total o su aceptación; y si, al vencimiento del citado plazo no se hubiera registrado la cancelación, se considerará que el mismo constituye';
        doc.text(cadena, 10, positionY);
        positionY = positionY + 3;
        cadena = 'título ejecutivo, en los términos del artículo 523 del Código Procesal Civil y Comercial de la Nación y concordantes.';
        doc.text(cadena, 10, positionY);
        positionY = positionY + 3;
        cadena = 'Su aceptación, expresa o tácita, implicará la plena conformidad para la transferencia de la información contenida en el documento desde el “Registro de Facturas Electrónicas MiPyMEs”'; 
        doc.text(cadena, 10, positionY);
        positionY = positionY + 3;
        cadena = 'a terceros, en caso de que el vendedor o locador optase por su cesión, transmisión o negociación.';
        doc.text(cadena, 10, positionY);
      }

      /* Total en letras */
      doc.setFont(fontName, 'normal');
      doc.setFontSize(7);
      // doc.setFontType('normal');
      doc.setTextColor(60, 60, 60);
      
      positionY = positionTotalesY + 20;
      let cadena = new String().concat(`Son: ${venta.monedaDescripcion} ${this.$options.filters.numeroALetras(venta.montoTotal)}`);
      doc.text(cadena, 10, positionY);

      /* Totales  */
      positionY += 2;
      doc.line(10, positionY, 200, positionY);      

      // doc.setFont(fontName);
      // doc.setFontSize(7);
      // doc.setFontType('normal');
      let positionLeyendaY = positionY + interlineadoTotales;

      if (venta.formulario == 'B') {

      } else {
        positionY += interlineadoTotales;
        doc.text('Neto Gravado:', 140, positionY);
        doc.text(this.$options.filters.moneda(venta.montoGravado, venta.moneda), 200, positionY, alignRight);
        positionY += interlineadoTotales;
        doc.text(`Iva Inscr. (${venta.pjeAlicuotaIva}%):`, 140, positionY);
        doc.text(this.$options.filters.moneda(venta.montoIvaInscripto, venta.moneda), 200, positionY, alignRight);
      }

      doc.setFont(fontBoldName, 'bold');
      positionY += interlineadoTotales;
      doc.text('Total:', 140, positionY);
      doc.text(this.$options.filters.moneda(venta.montoTotal, venta.moneda), 200, positionY, alignRight);

      if (venta.monedaId != 101) {
        doc.setFont(fontName, 'normal');
        positionY += interlineadoTotales;
        doc.text(`Total en moneda de curso legal - Pesos Argentinos:`, 96, positionY);
        doc.text(this.$options.filters.moneda(venta.montoTotalLocal), 200, positionY, alignRight);
        positionY += interlineadoTotales;
        doc.text(`Tipo de Cambio:`, 140, positionY);
        doc.text(this.$options.filters.moneda(venta.cotizacion), 200, positionY, alignRight);
      }

      if (venta.formulario == 'B') {
        let interlineadoLeyenda = 3;
        doc.setFont(fontName, 'normal');

        positionY += interlineadoTotales;
        doc.text('Regimen de Transparencia Fiscal al Consumidor (Ley 27743)', 130, positionY);
        positionY += interlineadoLeyenda;
        doc.text(`IVA Contenido: ${this.$options.filters.moneda(venta.montoIvaInscripto)}`, 130, positionY);
      }

      drawFooter(doc, empresa, venta, fontName, fontBoldName, fontItalicName, fontBoldItalicName, positionLeyendaY);

      window.open(doc.output("bloburl", { filename: 'venta.pdf' } ));

      return;
    },
  }
}

function drawCabecera(doc, empresa, venta, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName) {
  let alignRight = {
    'align': 'right'
  }

  /* Verificamos si tiene logo asociado */
  let logoAsociado = (empresa.logoWeConnect.trim() != '')? true : false;

  let ajusteY = 0;
  if (venta.afipComprobante > 200) {
    ajusteY = 5;
  }

  drawCabeceraFiscalEmpresa({
    doc, 
    empresa, 
    fontName, 
    ajusteY,
    dark: false,
    logoAsociado
  });

  /* Tipo de comprobante */ 
  doc.setTextColor(151, 148, 149);
  doc.rect(98, 8, 14, 14);

  doc.setFont(fontBoldName, 'bold');
  // doc.setFontType('normal');
  doc.setFontSize(24);
  doc.text(venta.formulario, 102, 16.5);

  doc.setFont(fontName, 'normal');
  doc.setFontSize(7);
  let cadena = new String().concat('COD.', venta.afipComprobante.toString().padStart(3, '0'));
  doc.text(cadena, 100, 20);

  doc.setFontSize(10);
  // doc.setTextColor(232, 67, 113);
  doc.setTextColor(empresa.imagenColorR || 232, empresa.imagenColorG || 67, empresa.imagenColorB || 113);

  let positionY = 18;
  if ((/true/i).test(logoAsociado)) {
    positionY = 40;
  }

  let ventaNumeroPuntoVenta = "0000" + venta.numeroPuntoVenta;
  ventaNumeroPuntoVenta = ventaNumeroPuntoVenta.substr(ventaNumeroPuntoVenta.length - 4);
  let ventaNumero = "0000000" + venta.numero;
  ventaNumero = ventaNumero.substr(ventaNumero.length - 8);
  //doc.text(cadena, 160, positionY);
  cadena = new String().concat(venta.comprobanteTipo, ' ', venta.formulario, ' ', ventaNumeroPuntoVenta, '-', ventaNumero);
  doc.text(cadena, 200, positionY, alignRight);
  doc.setTextColor(0, 0, 0);
  positionY += 5;
  cadena = new String().concat('Fecha: ', moment(venta.fechaComprobante).format('DD/MM/YYYY'));
  doc.text(cadena, 200, positionY, alignRight);
  /* Fecha de vencimiento para */
  if (venta.afipComprobante > 200) {
    positionY += 5;
    cadena = new String().concat('Fecha de Vencimiento: ', moment(venta.fechaVencimiento).format('DD/MM/YYYY'));
    doc.text(cadena, 200, positionY, alignRight);
  }

  doc.setFontSize(8);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);

  positionY = 55 + ajusteY;
  if ((/true/i).test(logoAsociado)) {
    positionY = 60 + ajusteY;
  }

  doc.line(10, positionY, 200, positionY);

  /* Datos del cliente */
  doc.setTextColor(60, 60, 60);

  positionY += 5;
  doc.text(`Cliente: ${venta.razonSocial.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Cond. Fiscal: ${venta.condicionFiscal.trim()}`, 10, positionY);
  // doc.text(`CUIT: ${venta.documentoNumero.trim()}`, 120, positionY);
  doc.text(`${venta.documentoTipo.trim()}: ${venta.documentoNumero.trim()}`, 120, positionY);
  positionY += 4;
  doc.text(`Domicilio: ${venta.direccion.trim()}`, 10, positionY);
  positionY += 4;
  doc.text(`Localidad: ${venta.localidad.trim()}`, 10, positionY);

  doc.setDrawColor(151, 148, 149); 
  doc.setLineWidth(0.3);
  positionY += 4;
  doc.line(10, positionY, 200, positionY);

  return positionY;
}

function drawFooter(doc, empresa, venta, 
  fontName, fontBoldName, fontItalicName, fontBoldItalicName, positionLeyendaY) {

  let alignRight = {
    'align': 'right'
  }

  /* Interlineado */
  let interlineado = 3;

  doc.setFont(fontName, 'normal');
  // doc.setFontType('normal');

  let positionY = positionLeyendaY;
  let cadena = 'CERVETTI MARKETING & EVENTOS S.A.S. CUIT 30-71631775-3 es titular en Banco';
  doc.text(cadena, 10, positionY);
  positionY += interlineado;
  cadena = 'Galicia de Buenos Aires de la CTA.CTE. en pesos Nº 276-1 218-1 con CBU';
  doc.text(cadena, 10, positionY);
  positionY += interlineado;
  cadena = '0070218020000000276119 - CBU Alias CERVETTI.SAS.GALICIA la cual se encuentra';
  doc.text(cadena, 10, positionY);
  positionY += interlineado;
  cadena = 'radicada en la Suc. 218 Tribunales del Banco Galicia.';
  doc.text(cadena, 10, positionY);

  if (venta.codigoCAE) {
    if (venta.codigoCAE.trim() != '') {

      let cuit = empresa.documentoNumero.trim().replaceAll('-', '');
      // let cuit = empresa.cuit.trim().replaceAll('-', '');
      let nroDocRec = venta.documentoNumero.trim().replaceAll('-', '');

      let json = `{"ver":1,"fecha":"${moment(venta.fechaComprobante).format('YYYY-MM-DD')}","cuit":${cuit},"ptoVta":${venta.numeroPuntoVenta.toString().trim()},"tipoCmp":${venta.afipComprobante.toString().trim()},"nroCmp":${venta.numero.toString()},"importe":${venta.montoTotal * 100},"moneda":"PES","ctz":1,"tipoDocRec":80,"nroDocRec":${nroDocRec},"tipoCodAut":"E","codAut":${venta.cae.trim()}}`;

      let url = `https://www.afip.gob.ar/fe/qr/?p=${btoa(json)}`;

      let positionY = 270;

      var qr = new VanillaQR({
        // url
        url: url,
        // width/height in pixels
        width: 400,
        height: 400,
        // colors
        colorLight: "#FFFFFF",
        colorDark: "#000000",
        // output as table or canvas
        toTable: false,
        // Ecc correction level 1-4
        ecclevel: 1,
        // Use a border or not
        noBorder: false,
        // Border size to output at
        borderSize: 2
      });

      var qrImage = qr.toImage("png");
      doc.addImage(qrImage.src, 'png', 10, positionY, 35, 35, undefined, 'FAST');

      // /* Logo AFIP */
      // doc.addImage(getBase64LogoAfip(), 'PNG', 45, positionY + 5, 18, 6);

      /* Datos de CAE */
      doc.setFont(fontName, 'normal');
      doc.setFontSize(7);
      // doc.setFontType('normal');

      positionY += 10;
      doc.text(`CAE Nº: ${venta.cae}`, 200, positionY, alignRight);
      positionY += 5;
      doc.text(`Fecha de Vto. CAE: ${moment(venta.fechaVencimientoCAE).format('DD/MM/YYYY')}`, 200, positionY, alignRight);
    }
  } 
}